import React from 'react';
import CustomerPhoneEdit from '../v3/checkout/subcomponents/CustomerPhoneEdit';

const ParentChangePhone = () => {
  return <CustomerPhoneEdit onSuccessRoute="/my-account" />;
};

export default ParentChangePhone;
